import { Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { startWith, switchMap } from 'rxjs';

import { TimeService } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { DatePickerComponent } from '@core/time-ui';
import {
  ButtonComponent,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownHeaderComponent,
  IconComponent,
  InputComponent,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-date-field',
  templateUrl: './evaluation-date-field.component.html',
  styleUrls: ['./evaluation-date-field.component.less'],
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownHeaderComponent,
    IconComponent,
    InputComponent,
    OverlayOriginDirective,
    DatePickerComponent,
    TranslatePipe,
  ],
})
export class EvaluationDateFieldComponent {
  private readonly timeService = inject(TimeService);

  public readonly control = input.required<FormControl<string | null>>();

  protected value = toSignal(
    toObservable(this.control).pipe(
      switchMap(control => control.valueChanges.pipe(startWith(control.value))),
    ),
    { initialValue: null },
  );

  protected getSelectedDate(value: string | null): string | null {
    if (!value) return null;
    return this.timeService.format({ input: value, pattern: 'DD MMM YYYY' });
  }
}
